export default __webpack_public_path__ + "static/media/Delivery_Tracking.01e8bae9.svg";